import GoogleMapsLoader from 'google-maps';
// import isIe from '@/scripts/utils/detect-ie';
import mapStyles from './styles.json';
import './googleMaps.scss';

export default function (el) {
  const {
    key,
    options,
    coords,
    markerOptions,
  } = el.dataset;
  const { lat, lng } = JSON.parse(coords);
  GoogleMapsLoader.KEY = key;

  const finalMarkerOptions = markerOptions ? JSON.parse(markerOptions) : {};

  return GoogleMapsLoader.load((google) => {
    const center = new google.maps.LatLng(lat, lng);
    const map = new google.maps.Map(el, {
      center,
      styles: mapStyles,
      ...JSON.parse(options),
    });
    const marker = new google.maps.Marker({
      position: center,
      ...finalMarkerOptions,
    });
    marker.setMap(map);
  });
}



// WEBPACK FOOTER //
// ./scripts/utils/googleMaps/googleMaps.js